import type {
  CommandPaletteBookReferenceHandler,
  ParsedCommandPaletteBookReferenceQuery,
} from 'types/commandPaletteBookReference';
import { COMMAND_PALETTE_BOOK_REFERENCE_HANDLERS } from 'utils/commandPaletteBookReferenceRegistry';

/** PREFIX + `-` + optional digits (e.g. INV-001, BILLPMT-012). */
export function parseCommandPaletteBookReferenceQuery(
  query: string,
  handlers: readonly CommandPaletteBookReferenceHandler[] = COMMAND_PALETTE_BOOK_REFERENCE_HANDLERS,
): ParsedCommandPaletteBookReferenceQuery | null {
  const trimmed = query.trim();
  if (!trimmed) {
    return null;
  }

  const dashIndex = trimmed.indexOf('-');
  if (dashIndex < 1) {
    return null;
  }

  const prefix = trimmed.slice(0, dashIndex).toUpperCase();
  const sequencePart = trimmed.slice(dashIndex + 1);
  if (!/^\d*$/.test(sequencePart)) {
    return null;
  }

  const handler = handlers.find((entry) => entry.prefix === prefix);
  if (!handler) {
    return null;
  }

  return {
    prefix,
    sequencePart,
    normalizedQuery:
      sequencePart.length > 0 ? `${prefix}-${sequencePart}` : `${prefix}-`,
    handler,
  };
}
